import { render, staticRenderFns } from "./ManifestActions.vue?vue&type=template&id=3666dfb0"
import script from "./ManifestActions.vue?vue&type=script&lang=js"
export * from "./ManifestActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports